export const paylineColors = [
    0xffeb3b, // 1  yellow
    0xff9800, // 2  orange
    0xffc107, // 3  amber
    0xf48fb1, // 4  pink-light
    0xe91e63, // 5  pink
    0xab47bc, // 6  purple
    0xba68c8, // 7  violet
    0x7e57c2, // 8  deep-purple
    0x29b6f6, // 9  cyan-blue
    0xc8b08a, // 10 tan
    0xeeeeee, // 11 white
    0xffeb3b, // 12 yellow
    0x3f51b5, // 13 indigo
    0xff5252, // 14 red
    0x2e7d32, // 15 green
    0xc77dff, // 16 lilac
    0x795548, // 17 brown
    0xff7043, // 18 deep-orange
    0xec407a, // 19 magenta
    0xa1887f, // 20 brown-light
    0x00acc1, // 21 cyan
    0x8d6e63, // 22 brown-mid
    0x9ccc65, // 23 lime
    0x5c6bc0, // 24 indigo-light
    0xd84315, // 25 burnt
];
